import CategorySidebar from '@components/CategorySidebar';
import Error from '@lib/Error';
import Loading from '@lib/Loading';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { CategoryContext } from '../../../../common/context/CategoryContext';
import { useCategoryAttributesForm } from '../../../../common/context/CategoryContext/hooks';
import { categoryAttributesSubmitHandler } from '../../../../common/context/CategoryContext/utils';

interface AttributesModalProps {
  closeModal: () => void;
}

const AttributesModal: React.FC<AttributesModalProps> = ({ closeModal }) => {
  const { category, categoryProductsSlice, categoryAttributes } = useContext(CategoryContext);
  const dispatch = useDispatch();
  const categoryAttributesForm = useCategoryAttributesForm({
    categoryProductsSlice,
    categoryAttributes,
    dispatch,
    shouldFetchOnFacetChange: false,
    shouldFetchOnPriceChange: false,
  });
  return (
    <div className="fixed flex flex-col w-full h-full left-0 bg-white z-50 top-0 p-20 overflow-y-scroll overflow-x-hidden">
      <div className="flex mb-24 justify-center mt-20">
        <div className="flex  text-18 font-bold">Filters</div>
      </div>

      {!category.isFetched ? (
        <Loading />
      ) : category.isFetched && category.error ? (
        <Error message={category.error} />
      ) : (
        <CategorySidebar category={category.category} hideCategories categoryAttributesForm={categoryAttributesForm} />
      )}
      <br />
      <div
        className="flex flex-col flex-1 fixed bottom-0 left-0 right-0 bg-white px-20 py-10"
        font-customisation="para-text"
      >
        <div className="flex mt-auto justify-evenly">
          <button
            onClick={() => closeModal()}
            className="font-bold tracking-14 mr-6 w-182 h-40 text-14 text-theme rounded bg-disabled"
            button-customisation="page-button"
          >
            CANCEL
          </button>
          <button
            className="font-bold tracking-14 w-182 h-40 text-14 text-white rounded bg-theme"
            onClick={() => {
              categoryAttributesSubmitHandler({ values: categoryAttributesForm.form.values });
              closeModal();
            }}
            button-customisation="buyNow-button"
          >
            APPLY
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttributesModal;
